import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=2d6b67d2&scoped=true"
import script from "./ExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ExpansionPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b67d2",
  null
  
)

export default component.exports